<template>
  <div class="gs-section-search">
    <gs-icon class="gs-section-search__icon" name="search" size="15" />
    <input
      class="gs-section-search__input"
      type="search"
      autocomplete="off"
      :value="value"
      :placeholder="placeholder"
      :aria-label="placeholder"
      @input="$emit('input', $event.target.value)"
    />
    <button
      v-if="value"
      type="button"
      class="gs-section-search__clear"
      title="Clear search"
      aria-label="Clear search"
      @click="clear()"
    >
      <gs-icon name="x" size="14" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'SectionSearch',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search',
    },
  },
  methods: {
    clear() {
      this.$emit('input', '');
    },
  },
};
</script>

<style scoped>
.gs-section-search {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 260px;
  max-width: 100%;
  min-height: 38px;
  padding: 0 8px 0 11px;
  background: var(--gs-input);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-sm);
}

.gs-section-search:focus-within {
  border-color: var(--gs-active-border);
  box-shadow: 0 0 0 3px var(--gs-ring);
}

.gs-section-search__icon {
  flex: none;
  color: var(--gs-muted-foreground);
}

.gs-section-search__input {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0;
  color: var(--gs-foreground);
  font: inherit;
  font-size: 14px;
  background: transparent;
  border: 0;
}

.gs-section-search__input:focus {
  outline: none;
}

/* Safari draws its own clear affordance on top of ours. */
.gs-section-search__input::-webkit-search-cancel-button {
  display: none;
}

.gs-section-search__input::placeholder {
  color: var(--gs-muted-foreground);
  opacity: 1;
}

.gs-section-search__clear {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  color: var(--gs-muted-foreground);
  background: transparent;
  border: 0;
  border-radius: 999px;
  cursor: pointer;
}

.gs-section-search__clear:hover {
  color: var(--gs-foreground);
  background: var(--gs-muted);
}

.gs-section-search__clear:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--gs-ring);
}

@media (max-width: 640px) {
  .gs-section-search {
    width: 100%;
  }
}
</style>
